<template>
  <div class="hello">
    <h1>This is just some site</h1>
    <footer class="footer">
      <h3>Contact details:</h3>
      <h5>email: sagicoh.games@gmail.com</h5>
    </footer>
  </div>
</template>

<script>
export default {
  name: "HelloWorld",
};
</script>

<!-- Add "scoped" attribute to limit CSS to this component only -->
<style scoped>
h1 {
  padding: 10px;
}
.footer {
  position: fixed;
  width: 100%;
  bottom: 0;
  flex-shrink: 0;
  padding: 20px;
  background: #000;
  color: white;
}
</style>
